<template>
  <div class="btn_box" :class="disabled && 'disabled'" @touchend.stop.prevent="handleClick">
    {{ text }}
  </div>
</template>

<script>
export default {
  name: 'CommonBtn',
  props: {
    text: String,
    disabled: {
      type: Boolean,
      default: false
    },
    onClick: Function
  },
  methods: {
    handleClick() {
      if (this.disabled) return
      this.onClick && this.onClick()
    }
  }
}
</script>

<style scoped>
.btn_box {
  display: flex;
  padding: 0.1rem 0.12rem;
  justify-content: center;
  align-items: center;
  width: 2.4rem;
  height: 0.48rem;
  line-height: 0.28rem;
  font-size: 0.2rem;
  font-weight: 600;
  color: #fff;
  border-radius: 0.08rem;
  background: #3fbb70;
  box-sizing: border-box;
}

.btn_box.disabled {
  background: #c6c6c6;
}
</style>



// WEBPACK FOOTER //
// src/components/CommonBtn.vue